import styled from 'styled-components';

import { primitive } from 'styles/constants/primitives';

export const HeroContent = styled.div`
  display: flex;
  flex-direction: column;
  padding: ${primitive.$spacing4} 0;
  min-height: 65vh;
  ${Styles.desktop`
    justify-content: center;
    padding: 15rem ${primitive.$spacing9} ${primitive.$spacing9};
    min-height: none;
  `}
`;
